(function($) {
  $(document).ready(function() {
    var openClass = 'expanded',
        expandAllButtonText = {
          'closed' : 'Vis alle',
          'open' : 'Lukk alle'
        },
        itemButtonQuery = '.list-group-item-heading[role=button]',
        expandAllButtonQuery = '.expand-all',
        itemQuery = '.list-group-item-heading',
        itemBody = '.list-group-item-body',
        defaultOpenItems = document.querySelectorAll('.js-default-open');

    // Kaller fn dersom event er av typen click eller keyCode 13
    function isClickOrEnterPressFilter(fn) {
      return function(event) {
        if (event.type === 'click' || event.keyCode === 13) {
          fn(event);
        }
      }
    }

    $('body')
        .on('click keypress', '.js-expandable ' + itemQuery, isClickOrEnterPressFilter(toggleExpandableItem))
        .on('click', '.js-expandable ' +  expandAllButtonQuery, toggleAllExpandable);

    function toggleExpandableItem(event) {
      var item = event.currentTarget;

      if($(item).parent().hasClass('expanded')) {
        closeItem(item);
      } else {
        openItem(item);
      }
    }

    function toggleAllExpandable(event) {
      var expandableCard = event.target.parentElement.parentElement;
      var items = $(expandableCard).find(itemButtonQuery);

      function performActionOnItems(func) {
        Array.prototype.forEach.call(items, function(item) {
          func(item);
        });
      }

      if(event.target.innerHTML == expandAllButtonText.closed) {
        performActionOnItems(openItem);
      } else {
        performActionOnItems(closeItem);
      }
      updateExpandAllButton(expandableCard);
    }


    function updateExpandAllButton(expandableCard) {

      function allItemsAreOpen(items) {
        var allAreOpen = true;
        Array.prototype.forEach.call(items, function(item) {
          if(!item.classList.contains(openClass)) {
            allAreOpen = false;
          }
        });
        return allAreOpen;
      }

      var items = $(expandableCard).find('.list-group-item.can-expand');
      var expandAllButton = $(expandableCard).find(expandAllButtonQuery);

      expandAllButton.html(allItemsAreOpen(items) ? expandAllButtonText.open : expandAllButtonText.closed);
    }

    function closeItem(item) {
      var parent = item.parentElement;
      var bodyEl = parent.querySelector(itemBody);

      parent.classList.remove(openClass);
      bodyEl.style.height = 0;
      changeAttibute(item, 'aria-expanded', false);
      changeAttibute(bodyEl, 'aria-hidden', true);

    }

    function openItem(item) {
      var parent = item.parentElement;
      if(!parent.classList.contains(openClass)) {
        var bodyEl = parent.querySelector(itemBody);

        var height = getRealHeight(bodyEl);
        parent.classList.add(openClass);
        bodyEl.style.height = height + 'px';
        bodyEl.style.visibility = 'visible';

        changeAttibute(item, 'aria-expanded', true);
        changeAttibute(bodyEl, 'aria-hidden', false);
      }

    }

    function getRealHeight(item) {
      item.style.visibility = 'hidden';
      item.style.height = 'auto';

      var realHeight = item.offsetHeight;

      item.style.height = '0';
      item.style.visibility = '';

      item.offsetHeight; // Trigger redraw before changing
      return realHeight;
    }

    function changeAttibute(item, attribute, value) {
      var attr = item.attributes.getNamedItem(attribute);
      if (attr) {
        attr.value = value;
        item.attributes.setNamedItem(attr);
      }
    }

    if(defaultOpenItems.length){
      for(var i=0; i < defaultOpenItems.length; i++){
        openItem(defaultOpenItems[i].querySelector(itemQuery));
      }
    }

  });
})(jQuery);
